export default "__VITE_ASSET__240e734a__"